module.exports = __webpack_public_path__ + "img/a5d70425b8b22e763c1bd4eedc1623b1.png";